// extracted by mini-css-extract-plugin
export default {"calendarEventIsComingMarginInputMargin":"calendarEventIsComingMarginInputMargin__n1QvS","calendarEventIsComingGroupMargin":"calendarEventIsComingGroupMargin__V5tGm"};